"use strict";

import data from "../data/cards";


function sanitizeString(str) {
  str = str.toLowerCase().trim();
  str = str.replace(/[`~!@#$%^&*()_|+\-=?;:"",.<>\{\}\[\]\\\/]/gi, "");
  str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  str = str.replace(/  | /gi, "-");
  return str;
}

function getFloatFromPrice(str) {
  str = str.indexOf("/") > -1 ? str.split("/")[0] : str;
  str = str.replace(/[$R \/mesanul]/g, "");
  str = str.replace(",", ".");
  return parseFloat(str);
}

function pushDataLayer(obj) {
  if (typeof obj !== "object") return false;
  window.dataLayer = window.dataLayer || [];
  dataLayer.push(obj);
}

function pushDataLayerBasicElements() {
  try {
    const whatsappButton = document.querySelector(".icon--flutuante a");

    if (whatsappButton) {
      whatsappButton.addEventListener("click", function () {
        pushDataLayer({
          event: "interaction",
          interaction: {
            component: "whatsapp-chat",
            action: "click-button",
            step: "",
            description: "compre-pelo-whatsapp",
            value: 0
          }
        });
      });
    }

    const navigationLinks = document.querySelectorAll(".navigation .navigation--nav");

    if (navigationLinks.length > 0) {
      navigationLinks.forEach(function (nav, index) {
        nav.addEventListener("click", function () {
          pushDataLayer({
            event: "interaction",
            interaction: {
              component: "nav",
              action: "click-link",
              step: (index + 1).toString() || "",
              description: sanitizeString(this.textContent) || "",
              value: 0
            }
          });
        });
      });
    }

    const policyLink = document.querySelector(".policy a");

    if (policyLink) {
      policyLink.addEventListener("click", function () {
        pushDataLayer({
          event: "interaction",
          interaction: {
            component: "politica-de-privacidade",
            action: "click-link",
            step: "",
            description: sanitizeString(this.textContent) || "",
            value: 0
          }
        });
      });
    }
  } catch (error) {
    console.error(error);
  }
}

function pushDataLayerBanner(obj) {
  const suffix = obj.view ? "View" : "Click";

  pushDataLayer({
    event: "promotion" + suffix,
    ecommerce: {
      ["promo" + suffix]: {
        promotions: [{
          id: obj.id || "",
          name: sanitizeString(obj.bannerTitle) || "",
          creative: obj.imgName || "",
        }]
      }
    }
  });
}

function pushDataLayerCard(obj) {
  const generalInfo = [];
  const prodsInfo = [];

  obj.forEach(item => {
    const dataCard = data.getDataCard(item.id);
    if (!dataCard) return;

    let plan, price, toggle;

    if (item.hasDoubleRedes) {
      toggle = 'adicionar';
      plan = dataCard.plan;
      price = dataCard.price;
    } else {
      toggle = 'remover';
      plan = dataCard.plan_sem_redes;
      price = dataCard.price_sem_redes;
    }

    generalInfo.push({
      ...item,
      plan: plan.toLowerCase(),
      price: getFloatFromPrice(price),
      toggle
    });

    prodsInfo.push({
      name: "vivo-controle-" + plan.toLowerCase(),
      id: dataCard.sku,
      price: getFloatFromPrice(price),
      originalPrice: getFloatFromPrice(dataCard.price_sem_redes),
      brand: "vivo",
      category: "plano-controle",
      variant: plan.toLowerCase() + "total-doubleredessociais-" + dataCard.gbRedesSociais.toLowerCase() + (dataCard.price_sem_redes.indexOf("/mês") > -1 ? "12m" : "1a"),
      quantity: 1
    });
  });

  if (generalInfo.length === 0 && prodsInfo.length === 0) return;

  if (generalInfo[0].type === 'impression') {
    pushDataLayer({
      event: "productImpression",
      ecommerce: {
        currencyCode: "BRL",
        impressions: prodsInfo,
      }
    });
  } else if (generalInfo[0].type === 'productclick') {
    pushDataLayer({
      event: "productClick",
      ecommerce: {
        click: {
          actionField: { list: "vivo-controle" },
          products: prodsInfo
        }
      }
    });

    if (generalInfo[0].innerType === 'cta') {
      pushDataLayer({
        event: "interaction",
        interaction: {
          component: "card",
          action: "click-button",
          step: (generalInfo[0].index + 1).toString() || "",
          description: "contratar:" + generalInfo[0].plan || "",
          value: generalInfo[0].price || 0
        }
      });
    }

    if (generalInfo[0].innerType === 'toggle') {
      pushDataLayer({
        event: "interaction",
        interaction: {
          component: "card",
          action: "click-button",
          step: (generalInfo[0].index + 1).toString() || "",
          description: generalInfo[0].toggle + "-internet" || "",
          value: generalInfo[0].price || 0
        }
      });
    }
  }
}

export {
  pushDataLayerBasicElements,
  pushDataLayerBanner,
  pushDataLayerCard,
}
